import { render, staticRenderFns } from "./consume-management.vue?vue&type=template&id=9945d5a4&scoped=true"
import script from "./consume-management.ts?vue&type=script&lang=ts&external"
export * from "./consume-management.ts?vue&type=script&lang=ts&external"
import style0 from "./consume-management.scoped.scss?vue&type=style&index=0&id=9945d5a4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9945d5a4",
  null
  
)

export default component.exports